"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveTypographyVariantStyles = void 0;
/**
 * Used to apply specific typography styles to button variants.
 *
 * @export
 * @param {Theme} theme
 * @param {string} variant
 * @return {*}  {React.CSSProperties}
 */
function resolveTypographyVariantStyles(theme, variant) {
    var _a, _b, _c, _d;
    var styleFn = (_d = (_c = (_b = (_a = theme.components) === null || _a === void 0 ? void 0 : _a.MuiTypography) === null || _b === void 0 ? void 0 : _b.variants) === null || _c === void 0 ? void 0 : _c.find(function (v) { var _a; return ((_a = v.props) === null || _a === void 0 ? void 0 : _a.variant) === variant; })) === null || _d === void 0 ? void 0 : _d.style;
    if (typeof styleFn === 'function') {
        return styleFn({ theme: theme });
    }
    return {};
}
exports.resolveTypographyVariantStyles = resolveTypographyVariantStyles;
